<template>
  <div class="dx-login-form">
    <form action="#" @submit="onSubmit">
      <div class="form-group">
        <label for="email">{{ $t('email') }}</label>
        <input id="email" type="text" class="form-control" v-model="model.email" required>
      </div>
      <div class="form-group">
        <label for="password">{{ $t('password') }}</label>
        <input id="password" type="password" class="form-control" v-model="model.password" required>
      </div>
      <dx-button :loading="sending" success type="submit">
        {{ $t('login') }}
      </dx-button>
    </form>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import {
  DxButton,
  DxSpinner
} from '../components'
export default {
  components: {
    DxButton,
    DxSpinner
  },
  data () {
    return {
      model: {
        email: '',
        password: ''
      },
      sending: false
    }
  },
  methods: {
    ...mapActions(['auth', 'notify']),
    onSubmit () {
      this.sending = true
      this.auth(this.model).then(() => {
        this.sending = false
        this.redirectAfterLogin()
      }).catch((error) => {
        this.notify({
          message: error.message,
          type: 'error'
        })
        this.sending = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DxLoginForm.vue